<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card>
      <v-toolbar dense class="">
        <v-toolbar-title>Report Group</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card>
          <v-card-text>
            <v-combobox
              :items="reportGroups"
              label="Select Group"
              item-value="id"
              hide-details
              item-text="name"
              v-model="selectedGroup"
              :search-input.sync="newReportGroup"
              chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <span class="subheading pr-2">Press Enter to Create</span>
                  <v-chip
                    label
                    small
                  >
                    {{ newReportGroup }}
                  </v-chip>
                </v-list-item>
              </template>
            </v-combobox>
            <v-row class="pt-2">
              <v-col>
                <v-list-item class="pa-0">
                  <v-list-item-content>
                    <!-- <v-list-item-title class="pb-1">Following Posts will be added to group.</v-list-item-title> -->
                    <v-list-item-subtitle :key="index" v-for="(post, index) in selectedPosts"><v-icon color="green" small>mdi-check</v-icon> {{post.instagram}} - {{post.type}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="success" :disabled="!selectedGroup" @click="saveReportGroup">Save changes</v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import campaignAPIs from './campaignAPIs';
export default {
  name: 'ReportGroupModal',
  props: {
    selectedPosts: Array,
    campaignID: String,
    value: Boolean
  },
  data () {
    return {
      reportGroups: [],
      selectedGroup: '',
      newReportGroup: '',
      loading: false
    }
  },
  watch: {
    value: function(newValue) {
      if (newValue === true) {
        this.getReportGroups() // refresh report groups on modal open
      }
    }
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
    async saveReportGroup() {
      const formData = this.buildFormData()
      this.loading = true
      try {
        let response = await campaignAPIs.addReportGroup(formData)
        if (response) {
          this.getReportGroups()
          // Return the newly added data to parent component
          this.loading = false;
          this.$swal({
            title: 'Successful',
            text: `Reports are added to (${response.group.name || '-'})`,
            type: 'success'
          }).then(() => {
            this.$emit('input')
            this.$emit('saved', true);
          });
        }
      } catch (error) {
        this.loading = false;
        this.$swal({
          title: 'Error',
          text: error,
          type: 'error'
        });
        console.log('error', error);
      }
    },
    buildFormData() {
      // if (typeof this.selectedGroup === 'string') {
      //   this.selectedGroup = {id: 0, name: this.selectedGroup}
      // }
      let formData = new FormData();
      formData.append('group', JSON.stringify(this.selectedGroup));
      formData.append('reports', JSON.stringify(this.selectedPosts.map(c => c.id)));
      return formData
    },
    closeModal() {
      this.$emit('input')
      this.selectedGroup = ''
    },
    async getReportGroups() {
      try {
        const resp = await campaignAPIs.getReportGroups(this.campaignID);
        if (resp.success) {
          this.reportGroups = resp.data;
          this.selectedGroup = ''
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportGroupModal.vue?b50449ac